<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
      <img src="../assets/images/code_cafe.png" alt="..." class="img-thumbnail">
    <a class="navbar-brand nav-link" href="#">Coder Cafe</a>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" routerLink="/create" routerLinkActive="active">Order</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/list-users" routerLinkActive="active">View Order</a>
        </li>
      </ul>
    </div>
  </div>
</nav>

<div class="container mt-5">
  <router-outlet></router-outlet>
</div>